/**
 *
 * QualitativeQuestionList
 *
 */

import React from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { makeSelectIsLoadingAnswers, makeSelectAnswers } from "./selectors"
import reducer from "./reducer"
import saga from "./saga"
import QuestionCard from "../../../components/QuestionCard"
import empty_meditions from "../../../images/emptyQuestionsReports.svg"
import { getQualitativeAnswersWatcher } from "./actions"
import { isEqual, filter } from "lodash"
import { Spin, Pagination, Empty } from "antd"
import "./index.less"
import { loadTexts } from "../../../utils/i18n"
import EmptyStateAnonymity from "components/EmptyStateAnonymity"


/* eslint-disable react/prefer-stateless-function */
export class QualitativeQuestionList extends React.PureComponent {
  state = {
    questions: [],
    columns: [],
    paginationCurrentPage: 1,
    paginationPageSize: this.props.total ? this.props.total : 15,
    rows: [],
  }

  intlQualitativeQuestion = loadTexts("reports_qualitative_questions_view")

  generate = () => {
    const { answers } = this.props
    const { rows } = this.state
    let initial = 1
    const newCol = []
    if (Array.isArray(rows)) {
      rows.map((e) => {
        if (!newCol[initial - 1]) {
          newCol[initial - 1] = []
        }
        newCol[initial - 1].push(e)
        initial++
        if (initial === 4) {
          initial = 1
        }
      })
      this.setState(
        { columns: newCol },
        this.props.totalAnswers(answers.length)
      )
    }
  }

  componentDidMount() {
    this.onChange(1)
  }

  componentDidUpdate(nextProps) {
    if (
      !isEqual(nextProps.answers, this.props.answers) ||
      this.props.textFilter != nextProps.textFilter
    ) {
      this.onChange(1)
    }
  }

  onChange = (page) => {
    const { answers, textFilter } = this.props
    const { paginationPageSize } = this.state
    this.setState(
      {
        paginationCurrentPage: page,
      },
      () => {
        let startIndex = (page - 1) * paginationPageSize
        let rows = answers
        if (textFilter) {
          rows = filter(rows, (item) => {
            return item.value
              .toLowerCase()
              .includes(textFilter.toLocaleLowerCase())
          })
        }
        let endIndex = Math.min(
          startIndex + paginationPageSize - 1,
          answers.length - 1
        )
        rows = rows.slice(startIndex, endIndex + 1)

        this.setState(
          {
            rows,
          },
          () => this.generate()
        )
      }
    )
  }

  countTotal = () => {
    const { answers, textFilter } = this.props
    if (textFilter) {
      return filter(answers, (item) => {
        return item.value.toLowerCase().includes(textFilter.toLocaleLowerCase())
      }).length
    }
    return answers.length
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ paginationPageSize: pageSize }, () => {
      this.onChange(1)
    })
  }




  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.question != this.props.question ||
      nextProps.division != this.props.division
    ) {
      this.props.getQualitativeAnswers({
        measure: nextProps.measure,
        question: nextProps.question,
        division: nextProps.division,
        measure_type: nextProps.measure_type,
        params: nextProps.location,
      })
    }
  }

  render() {
    const { columns, paginationCurrentPage } = this.state
    const { isLoadingAnswers, pagination, textFilter, wordCloud, divisionSelectedInfo, employees } = this.props


    if (isLoadingAnswers) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }
    if(wordCloud && this.countTotal() === 0){
      return (
        <EmptyStateAnonymity
          count={employees}
        />
      )
    }
    if (this.countTotal() === 0 && textFilter) {
      return (
        <Empty
          style={{ color: "#828282" }}
          image={empty_meditions}
          description={
            <span style={{ margin: "0 auto", maxWidth: 440, display: "block" }}>
              {this.intlQualitativeQuestion.noResultsFound}
            </span>
          }
          className="ReportsHome-empty-fix"
        />
      )
    }

    if (this.countTotal() === 0) {
      return (
        <div>
          <Empty
            style={{ color: "#828282" }}
            image={empty_meditions}
            description={
              <span
                style={{ margin: "0 auto", maxWidth: 440, display: "block" }}>
                {this.intlQualitativeQuestion.noResultsFound}
              </span>
            }
            className="ReportsHome-empty-fix"
          />
        </div>
      )
    }

    return (
      <div>
        <div className="QualitativeQuestionList">
          {columns.map((c, ci) => (
            <div key={ci} className="QualitativeQuestionList-column">
              {c.map((q, i) => (
                <QuestionCard key={i} title={q.name} description={q.value} />
              ))}
            </div>
          ))}
        </div>
        {pagination && (
          <Pagination
            defaultPageSize={this.props.total ? this.props.total : 15}
            pageSizeOptions={["15", "25", "50", "100"]}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            onChange={this.onChange}
            defaultCurrent={paginationCurrentPage}
            total={this.countTotal()}
          />
        )}
      </div>
    )
  }
}

QualitativeQuestionList.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoadingAnswers: makeSelectIsLoadingAnswers(),
  answers: makeSelectAnswers(),
})

function mapDispatchToProps(dispatch) {
  return {
    getQualitativeAnswers: (params) =>
      dispatch(getQualitativeAnswersWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({
  key: "qualitativeQuestionListInside",
  reducer,
})
const withSaga = injectSaga({ key: "qualitativeQuestionListInside", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(QualitativeQuestionList)
